import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrl: './delete-confirmation-dialog.component.css',
    standalone: false,
})
export class DeleteConfirmationDialogComponent {
    deleteIsEnabled: boolean = false;
    inputName: string;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title: string;
            name: string;
            message1: string;
            message2?: string;
            cancelButton?: string;
            buttonDelete?: string;
            requireInput?: boolean;
            inputLegend?: string;
            inputPlaceholder?: string;
        },
        private dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>
    ) {}

    deleteElement() {
        if (this.deleteIsEnabled) this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    nameChange(input) {
        this.inputName = input;
        this.deleteIsEnabled = this.inputName === this.data.name;
    }
}
